"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M9.78,19.89a9.15,9.15,0,1,1,9-10.7.6.6,0,1,1-1.19.2,7.94,7.94,0,1,0-5,8.76.6.6,0,1,1,.43,1.13A9.11,9.11,0,0,1,9.78,19.89Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M14.83,11.34H4.73a.6.6,0,1,1,0-1.21h10.1a.6.6,0,1,1,0,1.21Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M10.55,15.62a.6.6,0,0,1-.43-1L14,10.74,10.13,6.89A.6.6,0,0,1,11,6l4.27,4.27a.6.6,0,0,1,0,.85L11,15.44A.6.6,0,0,1,10.55,15.62Z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M17.32,21.31a1.1,1.1,0,0,0,2.19,0ZM22.2,19V15.8a3.79,3.79,0,0,0-2.91-3.69v-.4a.88.88,0,0,0-1.75,0v.4a3.79,3.79,0,0,0-2.91,3.69V19l-1.17,1.17v.58h9.92v-.58Z"
  })));
};

exports["default"] = _default;